import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=894a2b3a&"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports